import React from 'react';
import PartnerLogo from '@components/Shared/PartnerLogo/PartnerLogo';
import InteractiveJobMap from '@components/Shared/InteractiveJobMap/InteractiveJobMap';
import { ComponentContainerProps } from 'types/Shared/ComponentContainer';
import BuilderLinksByState from '@components/OurBuilders/BuilderLinksByState';

type Props = ComponentContainerProps;

export default function ComponentContainer({ section }: Props): JSX.Element {
  switch (section.component) {
    case 'Partner Logo Section': {
      return <PartnerLogo section={section} />;
    }
    case 'Retail Interactive Job Map': {
      return <InteractiveJobMap section={section} />;
    }
    case 'Builder Links By State': {
      return <BuilderLinksByState section={section} />;
    }
    default: {
      return <></>;
    }
  }
}
